import { styled } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const StreamilyButtonSmall = styled(Button)(({ theme }) => ({
  textTransform: "none",
  backgroundColor: theme.palette.primary.main,
  boxShadow: "none",
  "&:disabled": {
    backgroundColor: theme.palette.grey.disabled,
  },
  transition: "background-color 150ms ease, box-shadow 150ms ease",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    boxShadow: theme.boxShadow.elevation2,
    filter: "brightness(1.05)",
  },
  color: "white",
  width: "100%",
  padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
  "&.offline": {
    backgroundColor: theme.palette.grey[500],
  },
}));

export default StreamilyButtonSmall;
